import ApiRequest from "../index"

const newsRequest = {
    getOptions: async data => ApiRequest.get(`/v2/lojinha/products/filter/all`),
    putNewOption: async data => ApiRequest.put(`/v2/lojinha/products/news/update`, {...data })
}   

export default newsRequest